<template>
  <div class="content flex-column">
    <div class="flex-space-between">
      <div class="operation flex-center-v">
        <el-select
            v-model="searchForm.dlName"
            size="small"
            filterable
            @change="handleChange"
            style="width:160px;margin-right:15px;">
          <el-option v-for="item in dlOptions" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
        <el-select
            v-model="searchForm.startYear"
            placeholder="开始年份"
            size="small"
            filterable
            @change="startYearChange"
            v-if="searchForm.dlName ==1 "
            style="width:140px;margin-right:15px;">
          <el-option v-for="item in yearOptions" :label="item+'年'" :value="Number(item)" :key="item"></el-option>
        </el-select>
        <el-select
            v-model="searchForm.endYear"
            placeholder="结束年份"
            size="small"
            filterable
            v-if="searchForm.dlName ==1 "
            style="width:140px;margin-right:15px;">
          <el-option v-for="item in yearOptions" :label="item+'年'" :value="Number(item)" :key="item" :disabled="item<searchForm.startYear"></el-option>
        </el-select>
        <el-input v-model="searchForm.departmentName" placeholder="请输入项目名称" size="small" style="width:140px;" clearable></el-input>
      </div>
      <div class="search" style="margin-bottom: 10px">
        <el-button type="primary" size="small" style="width:80px;" @click="exportTaiBan">导出</el-button>
        <el-button type="primary" size="small" style="width:80px;" @click="searchTaiBan">查询</el-button>
      </div>
    </div>
    <div class="cont flex-1-auto" v-if="searchForm.dlName == 0 ">
      <el-table :data="TaiBantableData" border height="100%" :header-cell-style="{background:'#f5f5f5',color:'#333333'}" key="table1">
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="name" label="项目名称" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div style="text-align: left;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"> {{ row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="countList" label="登高车总台班">
          <template slot-scope="{row}">
            <span>{{ row.countList[0] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="countList" label="登高车在用台班">
          <template slot-scope="{row}">
            <span>{{ row.countList[1] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="countList" label="登高车使用率">
          <template slot-scope="{row}">
            <span>{{ row.countList[2] }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="cont flex-1-auto" v-if="searchForm.dlName == 1 ">
      <el-table :data="TaiBantableData" border height="100%" :header-cell-style="{background:'#f5f5f5',color:'#333333'}" key="table2" :span-method="objectSpanMethod">
        <el-table-column align="center" prop="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="name" label="项目名称" width="200">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
              <div class="diaolanName" :title="scope.row.name">{{scope.row.name}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="分项内容" prop="countName"  width="200"></el-table-column>
        <el-table-column v-for="(item, index) in tableHeaderArrays" :key="index" :label="item" :prop="tableHeaderArrays[index]">
          <template slot-scope="scope">
            <div>{{scope&&scope.row.countMap[index] || '' }}{{scope.row.countName.indexOf("率") != -1 ?'%':''}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import apis from '../api/security-check.js'
import {downloadFile} from '@/utils/utils'
import BaseURL from '@/apis/baseurl'
export default {
  name: "six3",

  components: {},

  props: {},

  data() {
    return {
      searchForm: {
        departmentName: '',
        dlName:1,
        startYear:'',
        endYear:''
      },
      TaiBantableData: [],
      dlOptions:[
        {
          label:'按时间展示',
          value:1
        },
        {
          label:'按台班总数展示',
          value:0
        }
      ],
      yearOptions:[],
      tableHeaderArrays:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月','年累计','开工累计',],
    }
  },

  computed: {
    ...mapGetters(['companyId', 'optionItem'])
  },

  watch: {
    companyId() {
      this.initTaiBan()
    }
  },

  mounted() {
    this.yearOptions = this.getYear()
    this.searchForm.startYear = new Date().getFullYear()
    this.searchForm.endYear = new Date().getFullYear()
    this.initTaiBan()
  },

  methods: {
    initTaiBan() {
      this.TaiBantableData = []
      if(this.searchForm.dlName == 0){
        const params = {
          departmentId: this.optionItem.departmentId,
          departmentType: this.optionItem.departmentType,
          departmentName: this.searchForm.departmentName,
          machineType:1
        }
        apis.largeMachineRecordTotalNew(params).then(res => {
          this.TaiBantableData = res
        })
      }else{
        const params = {
          departmentName: this.searchForm.departmentName,
          startYear: this.searchForm.startYear,
          endYear:this.searchForm.endYear,
          departmentType: this.optionItem.departmentType,
          departmentId: this.optionItem.departmentId,
          machineType:1
        }
        apis.largeMachineRecordTotalByYearNew(params).then(res => {
          res.forEach((item,index)=>{
            Object.entries(item.countMap).forEach(([key, value]) => {
              this.TaiBantableData.push({name:item.name,countName:key,countMap:value,index:index+1})
            });
          })
        })
      }

    },
    searchTaiBan() {
      this.initTaiBan()
    },
    exportTaiBan(){
      if(this.searchForm.dlName == 0){
        const params = {
          departmentId: this.optionItem.departmentId,
          departmentType: this.optionItem.departmentType,
          departmentName: this.searchForm.departmentName,
        }
        const url = BaseURL + `/admin/public/exportTotalMachineNew?machineType=1&departmentType=${params.departmentType}&departmentId=${params.departmentId}&departmentName=${params.departmentName}`
        downloadFile(url, {}, '登高车综合台班.xls')
      }else{
        const params = {
          startYear: this.searchForm.startYear,
          endYear: this.searchForm.endYear,
          departmentName: this.searchForm.departmentName,
          departmentId:this.optionItem.departmentId,
          departmentType:this.optionItem.departmentType,
        }
        const url = BaseURL + `/admin/public/exportTotalMachineByYearNew?machineType=1&startYear=${params.startYear}&endYear=${params.endYear}&departmentName=${params.departmentName}&departmentId=${params.departmentId}&departmentType=${params.departmentType}`
        downloadFile(url, {}, '登高车台班汇总台账.xls')
      }
    },
    getYear(){
      const array = []
      for (let i=0;i<60;i++){
        if (i<10){
          array.push('200'+i)
        }else{
          array.push('20'+i)
        }
      }
      return array
    },
    startYearChange(value){
      if( value > this.searchForm.endYear ){
        this.searchForm.endYear = value
      }
    },
    handleChange(){
      this.TaiBantableData = []
      this.initTaiBan()
    },
    objectSpanMethod({row,  rowIndex, columnIndex} ) {
      if (columnIndex === 0 || columnIndex === 1) {
        const currentValue = row.name;
        const prevRow = this.TaiBantableData[rowIndex - 1];
        const prevValue = prevRow ? prevRow.name : null;

        // 与上一行相同则隐藏
        if (currentValue === prevValue) {
          return { rowspan: 0, colspan: 0 };
        }

        // 计算连续相同值的数量
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.TaiBantableData.length; i++) {
          if (this.TaiBantableData[i].name === currentValue) {
            rowspan++;
          } else {
            break;
          }
        }
        return { rowspan, colspan: 1 };
      }
      return { rowspan: 1, colspan: 1 };
    }
  }
}
</script>


